<template>


  <div data-bak="定制机构login"
       v-if="brand_info && brand_info.air_login_page_style==='style_1' && userInfo.id"
       v-show="brand_info" class="header header_style_1" :class="$route.name.toLocaleLowerCase()+'-page'"
       :data-page="$route.name"
      :style="{backgroundColor:brand_info.air_newhome_bg_color}"
  >
    <div class="header-content w1200">
      <div class="logo">
        <div class="logo-icon" @click="() => this.$router.push('/')">
          <img class="logo_image" :src="logoImageUrl" alt=""/>
          <img class="logo_image_light" :src="logoImageUrl_light" alt=""/>
          <template v-if="$route.name.toLocaleLowerCase()!=='new_index'">
            <span class="logo-text">{{ brand_text }}</span>
          </template>
        </div>
        <div class="search-wrap">
          <YxpIcon type="iconlujing2636" @click="handleSearch"></YxpIcon>
          <input
              class="search-input"
              v-model="searchWord"
              @keyup.enter="handleSearch"
          />
        </div>
      </div>
      <div class="header-nav">
        <router-link to="/">
          <span
              class="nav-item"
              :class="{ 'nav-item__active': $route.name === ROUTER_MAP.home }"
          >首页</span>
        </router-link>
        <router-link to="/course_video" v-if="userInfo && userInfo.set_brand_info && userInfo.set_brand_info.course_modules  && userInfo.set_brand_info.course_modules.video==1">
          <span
              class="nav-item"
              :class="{
              'nav-item__active':$route.name.indexOf('course_video') !== -1}"
          >视频宝典</span>
        </router-link>
        <router-link to="/famous_read" v-if="userInfo && userInfo.is_show_famous_read">
          <span
              class="nav-item"
              :class="{
              'nav-item__active':$route.name.indexOf('famous_read') !== -1}"
          >名著阅读</span>
        </router-link>
        <router-link to="/word_test">
          <span
              class="nav-item"
              :class="{
              'nav-item__active':
                $route.name === ROUTER_MAP.word_test
            }"
          >词汇量测评</span>
        </router-link>


        <router-link to="/word_competition" v-if="(userInfo.course_schedule===0)">
          <span
              class="nav-item"
              :class="{
              'nav-item__active':
                $route.name === 'word_competition'
            }"
          >单词竞赛</span>
        </router-link>

        <router-link to="/mycourse" v-if="(userInfo.course_schedule===0)">
          <span
              class="nav-item"
              :class="{
              'nav-item__active': $route.name === ROUTER_MAP.myCourse
            }"
          >我的课表</span>
        </router-link>
        <div v-if="!userInfo.username && !userInfo.avatar" class="login-info">
          <a @click="loginHandle">登录</a>
        </div>
        <div v-if="userInfo.username || userInfo.avatar" class="user-wrap">
          <div class="notice-btn" @click="firstRenderMsgList">
            <template v-if="show_msg_box">
              <img v-if="$route.name.toLocaleLowerCase()!=='new_index'" src="~assets/msg/msg-select.png" alt="" style="height: 20px">
              <img v-else src="~assets/msg/msg-select-1.png" alt="" style="height: 20px">
            </template>
            <template v-else>
              <img v-if="$route.name.toLocaleLowerCase()!=='new_index'" src="~assets/msg/msg-un-select.png" alt="" style="height: 20px">
              <img v-else src="~assets/msg/msg-un-select-1.png" alt="" style="height: 20px">
            </template>
          </div>
          <div class="ui-msg-list" v-show="show_msg_box" ref="msg_list_div">
            <div class="ui-msg-list-item" v-for="(item,index) in msg_list" @click="viewMsg(item)">
              <div class="msg-hd">{{ item.title }}</div>
              <div class="msg-bd" v-if="item.type===2">{{ item.content }}</div>
              <div class="msg-ft">
                <div>
                  {{ item.created_at }}
                </div>
                <div v-if="item.type!==1">
                  查看详情
                  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2663"
                       width="100%" height="100%">
                    <path
                        d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z"
                        p-id="2664"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div class="ui_msg_no" v-show="no_msg_list">没有更多消息了</div>
          </div>
          <a-dropdown :trigger="['hover']">
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="logout">退出登录</a>
              </a-menu-item>
            </a-menu>
            <div class="user-info">
              <img class="user-avator" :src="userInfo.avatar" alt=""/>
              <span>{{ userInfo.username }}</span>
            </div>
          </a-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div data-bak="定制机构no-login" v-show="brand_info"
       v-else-if="brand_info && brand_info.air_login_page_style==='style_1' && !userInfo.id"
       class="header" :class="[$route.name.toLocaleLowerCase()+'-page',brand_info.theme_code]"
       :style="{ backgroundColor: `${brand_info.air_text_active_color}` }"
       :data-page="$route.name">
    <div class="header-content">
      <div class="logo_box_default" @click="to_homepage()">
        <div class="logo_image">
          <img :src="brand_info.logo_white_text_img" alt=""/>
        </div>
        <div class="logo_text">智能英语训练系统</div>
      </div>
      <div class="header-nav header_nav_default">
        <div v-if="!userInfo.username && !userInfo.avatar" class="login-info">
          <a @click="loginHandle">登录</a>
        </div>
        <div v-if="userInfo.username || userInfo.avatar" class="user-wrap">
          <div class="nav_items_default">
            <div class="item" style="display: none">
              <div class="label">
                <img src="../../../src/assets/homepage_v2/pk.png" alt="" />
              </div>
              <div class="text">单词pk</div>
            </div>
            <div class="item" style="display: none">
              <div class="label">
                <img src="../../../src/assets/homepage_v2/gendu.png" alt="" />
              </div>
              <div class="text">单词跟读</div>
            </div>
            <div class="item" @click="()=>this.$router.push('/')">
              <div class="label">
                <svg style="width: 25px;height: 27px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M947.19 405.06L540.8 100.27c-16.97-12.72-40.62-12.72-57.59 0L76.8 405.06c-14.14 10.59-17 30.66-6.39 44.8s30.64 17.05 44.8 6.39l52.8-39.6v412.66c0 36.78 29.91 66.69 66.67 66.69h554.67c36.75 0 66.66-29.91 66.66-66.69V416.64l52.81 39.61a31.708 31.708 0 0 0 19.16 6.41c9.75 0 19.34-4.42 25.62-12.8 10.62-14.14 7.74-34.2-6.41-44.8zM576 832H448v-93.35c0-34.74 28.26-63 63-63h2c34.74 0 63 28.26 63 63V832z m216-2.69c0 1.47-1.19 2.69-2.66 2.69H640v-93.35c0-70.14-56.86-127-127-127h-2c-70.14 0-127 56.86-127 127V832H234.67c-1.47 0-2.67-1.22-2.67-2.69V368.66l280-210 280 209.99v460.66z" fill="#ffffff" p-id="1537"></path></svg>
              </div>
              <div class="text">首页</div>
            </div>

            <div class="item" v-if="brand_info.course_modules.video">
              <div class="label" @click="()=>this.$router.push('/course_video')">
                <svg style="width: 23px;height: 24px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M387.398 325.052l308.427 178.843L387.398 684.32V325.05z m-1.707-72.642c-6.981-4.05-14.879-4.965-22.17-3.32-2.235-0.512-4.531-0.838-6.905-0.838-17.005 0-30.797 13.777-30.797 30.782v450.42c0 17.005 13.792 30.798 30.797 30.798 2.607 0 5.09-0.42 7.51-1.04a30.13 30.13 0 0 0 23.086-3.118l371.293-217.212c11.109-6.501 14.52-12.544 15.003-31.108 0.483-18.564 0.217-30.379-13.203-38.152L385.691 252.41zM527.39 960.764h-31.03C118.628 958.212 61.5 836.652 61.5 502.291c0-324.754 71.37-439.29 434.86-439.29h31.03c363.489 0 434.858 114.536 434.858 439.29 0 334.361-57.126 455.921-434.858 458.473M496.36 0C91.88 0-0.001 140.854-0.001 502.228c0 361.389 70.718 518.985 498.207 521.71h27.338c427.488-2.725 498.207-160.321 498.207-521.71C1023.751 140.854 931.87 0 527.39 0h-31.03z" fill="#ffffff" p-id="4112"></path></svg>
              </div>
              <div class="text">视频宝典</div>
            </div>

            <div class="item kjaldfjl" @click="firstRenderMsgList">
              <div class="label kjaldfjl">
                <img class="kjaldfjl" src="../../../src/assets/homepage_v2/tongzhi.png" alt="" />
              </div>
              <div class="text kjaldfjl">通知</div>
            </div>
            <a-dropdown :trigger="['hover']">
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;" @click="logout">退出登录</a>
                </a-menu-item>
              </a-menu>
              <div class="user-info">
                <img class="user-avator" :src="userInfo.avatar" alt=""/>
                <span>{{ userInfo.username }}</span>
              </div>
            </a-dropdown>
          </div>
          <div class="ui-msg-list" v-show="show_msg_box" ref="msg_list_div">
            <div class="ui-msg-list-item" v-for="(item,index) in msg_list" @click="viewMsg(item)">
              <div class="msg-hd">{{ item.title }}</div>
              <div class="msg-bd" v-if="item.type===2">{{ item.content }}</div>
              <div class="msg-ft">
                <div>
                  {{ item.created_at }}
                </div>
                <div v-if="item.type!==1">
                  查看详情
                  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2663"
                       width="100%" height="100%">
                    <path
                        d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z"
                        p-id="2664"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div class="ui_msg_no" v-show="no_msg_list">没有更多消息了</div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div data-bak="定制机构single_user_data" v-show="brand_info"
       v-else-if="brand_info && brand_info.single_user_data===1" class="header" :class="[$route.name.toLocaleLowerCase()+'-page',brand_info.theme_code]"
       :style="{ backgroundColor: `${brand_info.air_text_active_color}` }"
       :data-page="$route.name">
    <div class="header-content">
      <div class="logo_box_default" @click="to_homepage()">
          <div class="logo_image">
            <img :src="brand_info.logo_white_text_img" alt=""/>
          </div>
            <div class="logo_text">智能英语训练系统</div>
      </div>
      <div class="header-nav header_nav_default">
        <div v-if="!userInfo.username && !userInfo.avatar" class="login-info">
          <a @click="loginHandle">登录</a>
        </div>
        <div v-if="userInfo.username || userInfo.avatar" class="user-wrap">
          <div class="nav_items_default">
            <div class="item" style="display: none">
              <div class="label">
                <img src="../../../src/assets/homepage_v2/pk.png" alt="" />
              </div>
              <div class="text">单词pk</div>
            </div>
            <div class="item" style="display: none">
              <div class="label">
                <img src="../../../src/assets/homepage_v2/gendu.png" alt="" />
              </div>
              <div class="text">单词跟读</div>
            </div>
            <div class="item" @click="()=>this.$router.push('/')">
              <div class="label">
                <svg style="width: 25px;height: 27px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M947.19 405.06L540.8 100.27c-16.97-12.72-40.62-12.72-57.59 0L76.8 405.06c-14.14 10.59-17 30.66-6.39 44.8s30.64 17.05 44.8 6.39l52.8-39.6v412.66c0 36.78 29.91 66.69 66.67 66.69h554.67c36.75 0 66.66-29.91 66.66-66.69V416.64l52.81 39.61a31.708 31.708 0 0 0 19.16 6.41c9.75 0 19.34-4.42 25.62-12.8 10.62-14.14 7.74-34.2-6.41-44.8zM576 832H448v-93.35c0-34.74 28.26-63 63-63h2c34.74 0 63 28.26 63 63V832z m216-2.69c0 1.47-1.19 2.69-2.66 2.69H640v-93.35c0-70.14-56.86-127-127-127h-2c-70.14 0-127 56.86-127 127V832H234.67c-1.47 0-2.67-1.22-2.67-2.69V368.66l280-210 280 209.99v460.66z" fill="#ffffff" p-id="1537"></path></svg>
              </div>
              <div class="text">首页</div>
            </div>

            <div class="item" v-if="brand_info.course_modules.video">
              <div class="label" @click="()=>this.$router.push('/course_video')">
                <svg style="width: 23px;height: 24px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M387.398 325.052l308.427 178.843L387.398 684.32V325.05z m-1.707-72.642c-6.981-4.05-14.879-4.965-22.17-3.32-2.235-0.512-4.531-0.838-6.905-0.838-17.005 0-30.797 13.777-30.797 30.782v450.42c0 17.005 13.792 30.798 30.797 30.798 2.607 0 5.09-0.42 7.51-1.04a30.13 30.13 0 0 0 23.086-3.118l371.293-217.212c11.109-6.501 14.52-12.544 15.003-31.108 0.483-18.564 0.217-30.379-13.203-38.152L385.691 252.41zM527.39 960.764h-31.03C118.628 958.212 61.5 836.652 61.5 502.291c0-324.754 71.37-439.29 434.86-439.29h31.03c363.489 0 434.858 114.536 434.858 439.29 0 334.361-57.126 455.921-434.858 458.473M496.36 0C91.88 0-0.001 140.854-0.001 502.228c0 361.389 70.718 518.985 498.207 521.71h27.338c427.488-2.725 498.207-160.321 498.207-521.71C1023.751 140.854 931.87 0 527.39 0h-31.03z" fill="#ffffff" p-id="4112"></path></svg>
              </div>
              <div class="text">视频宝典</div>
            </div>

            <div class="item kjaldfjl" @click="firstRenderMsgList">
              <div class="label kjaldfjl">
                <img class="kjaldfjl" src="../../../src/assets/homepage_v2/tongzhi.png" alt="" />
              </div>
              <div class="text kjaldfjl">通知</div>
            </div>
            <a-dropdown :trigger="['hover']">
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;" @click="logout">退出登录</a>
                </a-menu-item>
              </a-menu>
              <div class="user-info">
                <img class="user-avator" :src="userInfo.avatar" alt=""/>
                <span>{{ userInfo.username }}</span>
              </div>
            </a-dropdown>
          </div>
          <div class="ui-msg-list" v-show="show_msg_box" ref="msg_list_div">
            <div class="ui-msg-list-item" v-for="(item,index) in msg_list" @click="viewMsg(item)">
              <div class="msg-hd">{{ item.title }}</div>
              <div class="msg-bd" v-if="item.type===2">{{ item.content }}</div>
              <div class="msg-ft">
                <div>
                  {{ item.created_at }}
                </div>
                <div v-if="item.type!==1">
                  查看详情
                  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2663"
                       width="100%" height="100%">
                    <path
                        d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z"
                        p-id="2664"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div class="ui_msg_no" v-show="no_msg_list">没有更多消息了</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div data-bak="非定制机构" v-show="brand_info" v-else class="header" :class="$route.name.toLocaleLowerCase()+'-page'" :data-page="$route.name">
    <div class="header-content w1200">
      <div class="logo">
        <div class="logo-icon" @click="() => this.$router.push('/')">
          <img class="logo_image" :src="logoImageUrl" alt=""/>
          <img class="logo_image_light" :src="logoImageUrl_light" alt=""/>
          <template v-if="$route.name.toLocaleLowerCase()!=='new_index'">
            <span class="logo-text">{{ brand_text }}</span>
          </template>
        </div>
        <div class="search-wrap">
          <YxpIcon type="iconlujing2636" @click="handleSearch"></YxpIcon>
          <input
              class="search-input"
              v-model="searchWord"
              @keyup.enter="handleSearch"
          />
        </div>
      </div>
      <div class="header-nav">
        <router-link to="/">
          <span
              class="nav-item"
              :class="{ 'nav-item__active': $route.name === ROUTER_MAP.home }"
          >首页</span>
        </router-link>
        <router-link to="/course_video" v-if="userInfo && userInfo.set_brand_info && userInfo.set_brand_info.course_modules  && userInfo.set_brand_info.course_modules.video==1">
          <span
              class="nav-item"
              :class="{
              'nav-item__active':$route.name.indexOf('course_video') !== -1}"
          >视频宝典</span>
        </router-link>
        <router-link to="/famous_read" v-if="userInfo && userInfo.is_show_famous_read">
          <span
              class="nav-item"
              :class="{
              'nav-item__active':$route.name.indexOf('famous_read') !== -1}"
          >名著阅读</span>
        </router-link>
        <router-link to="/word_test">
          <span
              class="nav-item"
              :class="{
              'nav-item__active':
                $route.name === ROUTER_MAP.word_test
            }"
          >词汇量测评</span>
        </router-link>


        <router-link to="/word_competition" v-if="(userInfo.course_schedule===0)">
          <span
              class="nav-item"
              :class="{
              'nav-item__active':
                $route.name === 'word_competition'
            }"
          >单词竞赛</span>
        </router-link>

        <router-link to="/mycourse" v-if="(userInfo.course_schedule===0)">
          <span
              class="nav-item"
              :class="{
              'nav-item__active': $route.name === ROUTER_MAP.myCourse
            }"
          >我的课表</span>
        </router-link>
        <div v-if="!userInfo.username && !userInfo.avatar" class="login-info">
          <a @click="loginHandle">登录</a>
        </div>
        <div v-if="userInfo.username || userInfo.avatar" class="user-wrap">
          <div class="notice-btn" @click="firstRenderMsgList">
            <template v-if="show_msg_box">
              <img v-if="$route.name.toLocaleLowerCase()!=='new_index'" src="~assets/msg/msg-select.png" alt="" style="height: 20px">
              <img v-else src="~assets/msg/msg-select-1.png" alt="" style="height: 20px">
            </template>
            <template v-else>
              <img v-if="$route.name.toLocaleLowerCase()!=='new_index'" src="~assets/msg/msg-un-select.png" alt="" style="height: 20px">
              <img v-else src="~assets/msg/msg-un-select-1.png" alt="" style="height: 20px">
            </template>
          </div>
          <div class="ui-msg-list" v-show="show_msg_box" ref="msg_list_div">
            <div class="ui-msg-list-item" v-for="(item,index) in msg_list" @click="viewMsg(item)">
              <div class="msg-hd">{{ item.title }}</div>
              <div class="msg-bd" v-if="item.type===2">{{ item.content }}</div>
              <div class="msg-ft">
                <div>
                  {{ item.created_at }}
                </div>
                <div v-if="item.type!==1">
                  查看详情
                  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2663"
                       width="100%" height="100%">
                    <path
                        d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z"
                        p-id="2664"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div class="ui_msg_no" v-show="no_msg_list">没有更多消息了</div>
          </div>
          <a-dropdown :trigger="['hover']">
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="logout">退出登录</a>
              </a-menu-item>
            </a-menu>
            <div class="user-info">
              <img class="user-avator" :src="userInfo.avatar" alt=""/>
              <span>{{ userInfo.username }}</span>
            </div>
          </a-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.ui_msg_no {
  display: block;
  text-align: center;
  padding: 0.5rem;
  color:#000;
}


.nav_items_default{
  display: flex;
  .item{
    margin-left: 2rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    .label{
        img{
          width: 45px;
        }
    }
    .text{

    }
  }
}
.header-nav.header_nav_default{
  .login-info{
    a{
      color:#fff;
      padding:0;
    }
  }
}
.ui-msg-list {
  position: absolute;
  z-index: 10000;
  top: 100%;
  right: 0;
  width: 400px;
  max-height: 390px;
  overflow-x: hidden;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 1px 3px 10px #999999;

  .ui-msg-list-item {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: flex-start;
    margin-top: .25rem;
    border-bottom: 1px solid rgba(0, 0, 0, .05);
    width: 100%;

    .msg-hd {
      padding: 0 10px;
      color: rgba(0, 0, 0, .9);
      font-size: 15px;
    }

    .msg-bd {
      padding: 5px 10px;
      color: rgba(0, 0, 0, .65);
      font-size: 12px;
    }

    .msg-ft {
      padding: 5px 10px;
      font-size: 10px;
      width: 100%;
      color: rgba(0, 0, 0, .45);
      display: flex;
      justify-content: space-between;

      div {
        display: inline-flex;
      }

      svg {
        width: 15px;
        height: 15px;
      }
    }
  }
}

.header {
  height: 70px;
  display: flex;
  align-items: center;
  min-width: 1200px;

  .logo {
    display: flex;
    align-items: center;

    .logo-icon {
      display: flex;
      cursor: pointer;
      align-items: center;

      .logo_image {
        display: inline-block;
      }

      .logo_image_light {
        display: none;
      }
    }

    .site-text {
      font-size: 20px;
      font-weight: bold;
    }

    .logo-text {
      padding-left: 30px;
      font-size: 22px;
      font-weight: bold;
      color: #42B8A2;
      position: relative;
      display: inline-block;

      &:before {
        display: block;
        position: absolute;
        left: 1rem;
        content: '';
        height: 80%;
        top: 10%;
        background-color: rgba(255, 255, 255, 0.3);
        width: 1px;
      }
    }

    img {
      width: 130px;
    }

    b {
      font-size: 20px; /* no */
      margin-left: 10px;
    }
  }

  &.home-page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    color: #fff;

    .logo {
      .logo-icon {
        .logo_image {
          display: none;
        }

        .logo_image_light {
          display: inline-block;
        }
      }

      .logo-text {
        color: #fff;
      }
    }

    .header-nav a {
      color: #fff;
    }
  }

  &.login-page-bak {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    color: #fff;

    .logo {
      .logo-icon {
        .logo_image {
          display: none;
        }

        .logo_image_light {
          display: inline-block;
        }
      }

      .logo-text {
        color: #fff;
      }
    }

    .header-nav a {
      color: #fff;
    }
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .search-wrap {
    display: none;
    align-items: center;
    padding: 0 11px;
    box-sizing: border-box;
    margin-left: 110px;
    border: 1px solid #42B8A2;
    width: 280px;
    height: 36px;
    border-radius: 30px;
    position: relative;

    .anticon {
      position: absolute;
      right: 1rem;
    }

    .search-input {
      border: none;
      outline: none;
      background-color: transparent;
      padding-left: 10px;
      width: 100%;
    }
  }

  .header-nav {
    display: flex;
    align-items: center;

    a {
      color: rgba(0, 0, 0, 1);
    }

    .nav-item {
      font-size: 1.15rem;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 7px 16px;
      position: relative;

      &.nav-item__active {
        color: #42B8A2;
      }

      &.nav-item__active:before {
        display: block;
        border-radius: 5px;
        content: ' ';
        width: 20px;
        height: 3px;
        position: absolute;
        bottom: 1px;
        background-color: #42B8A2;
      }

      &:hover {
        color: #42B8A2;
      }
    }
  }

  .search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;

    &:hover {
      background-color: #42B8A2;
    }
  }

  .login-info {
    & > a {
      font-size: 1.15rem;
      padding: 10px;
    }
  }

  .user-wrap {
    position: relative;
    display: flex;
    align-items: center;

    .notice-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 20px;
      cursor: pointer;
      position: relative;

      &.new:after {
        content: " ";
        display: block;
        position: absolute;
        z-index: 100;
        height: 8px;
        width: 8px;
        border-radius: 100%;
        background: red;
        top: 0;
        right: 0;
      }
    }

    .user-info {
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-radius: 22px; /* no */
      padding: 7px 14px;

      &:hover {
        background-color: #42B8A2;
        color: #fff;
      }

      .user-avator {
        display: block;
        margin-right: 12px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
    }
  }
}
.header.login-page{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  color: #fff;

  .logo {
    .logo-icon {
      .logo_image {
        display: none;
      }

      .logo_image_light {
        display: inline-block;
      }
    }

    .logo-text {
      color: #fff;
    }
  }

  .header-nav a {
    color: #fff;
  }
}
.header.theme_skin_1.login-page{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    color: #fff;

    .logo {
      .logo-icon {
        .logo_image {
          display: none;
        }

        .logo_image_light {
          display: inline-block;
        }
      }

      .logo-text {
        color: #fff;
      }
    }

    .header-nav a {
      color: #fff;
    }
}
.header{
  &.theme_skin_1{
    display: flex;
    align-items: center;
    background-color: rgba(51,157,108,1);
    color:#fff;
    min-width: 1200px;
    .header-content{
      margin: 0 auto;
      width: 960px;
    }
    .user-info{
      &:hover {
        background-color: transparent;
      }
      .user-avator{
        border-radius: 5px;
      }
      span{
        text-align: center;
        width: 100px;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      width: 130px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 22px;
      padding: 7px 14px;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
    }
    .logo_box_default{
      width: 130px;
      text-align: center;
      .logo_image{
        img{
          width: 130px;
        }
      }
      .logo_text{
        margin-right: -1rem;
        font-size: 14px;
      }
    }
  }
  &.theme_skin_2{
    display: flex;
    align-items: center;
    background-color:rgba(54,114,161,1);
    color:#fff;
    min-width: 1200px;
    .header-content{
      margin: 0 auto;
      width: 960px;
    }
    .user-info{
      &:hover {
        background-color: transparent;
      }
      .user-avator{
        border-radius: 5px;
      }
      span{
        text-align: center;
        width: 100px;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      width: 130px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 22px;
      padding: 7px 14px;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
    }
    .logo_box_default{
      width: 130px;
      text-align: center;
      .logo_image{
        img{
          width: 130px;
        }
      }
      .logo_text{
        margin-right: -1rem;
        font-size: 14px;
      }
    }
  }
  &.new_index-page{
    background-color: rgba(59,189,138,1);
    color:#fff;
    .header-content{
      .nav-item{
        color:#fff;
      }
    }
    .login-info{
      a{
        color:#fff;
      }
    }
  }
}
.header.header_style_1 .header-nav .nav-item:hover{
  color: #fff;
}
.header.header_style_1 .header-nav .nav-item.nav-item__active{
    color: #fff;
}
.header.header_style_1 .header-nav .nav-item.nav-item__active:before {
  background-color: rgba(254,169,63,1);
}
.header.header_style_1 .logo .logo-text{
  color:#fff;
}
</style>
<script>
import ROUTER_MAP from '@/router/router-map.js'
import mTypes from '@/store/mutationsTypes'
import { mapState, mapMutations } from 'vuex'
import { Dropdown, Menu } from 'ant-design-vue'
import store from '@/store'
import { fetchHomeCarousel, getBrandSkinConfig, getMsgList } from '@/services'

export default {
  name: 'HEADER',
  components: {
    ADropdown: Dropdown,
    AMenu: Menu,
    AMenuItem: Menu.Item
  },
  data () {
    return {
      first_render_msg:true,
      msg_list: [],
      no_msg_list: false,
      msg_list_page: 1,
      msg_list_max: 0,
      show_msg_box: false,
      logoImageUrl: '',
      logoImageUrl_light: '',
      brand_text: '',
      site_text: '',
      site_title: '',
      is_show_famous_read: false,
      ROUTER_MAP,
      searchWord: '',
      timer: null,
      brand_info:null,
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    })
  },
  watch: {
    $route (to, from) {
      if (!to.query.search) {
        this.searchWord = ''
      }
    }
  },
  methods: {
    to_homepage(){
      this.$router.push('/');
    },
    firstRenderMsgList(){
      this.show_msg_box=!this.show_msg_box;
      this.no_msg_list=false;
      this.msg_list_page=1;
        if (this.userInfo.id) {

          this.$nextTick(() => {
            this.containerScrollFn = this.throttle(this.msg_list_div_scroll_listen, 200)
            this.$refs.msg_list_div.addEventListener('scroll', this.containerScrollFn)
          })

          getMsgList({
            pageSize: 5,
            page: this.msg_list_page,
          }).then(response => {
            if (response.code === 1) {
              this.first_render_msg=false;
              this.msg_list_max = response.data.maxPage
              if (this.msg_list_max) {
                this.msg_list_page++
              }
              this.msg_list=response.data.list.map((item) => {
                if (item.content.length >= 15) {
                  item.content = (item.content.slice(0, 13) + '...')
                }
                return item;
              });
              if(!this.msg_list.length){
                this.no_msg_list=true;
              }
              store.commit(mTypes.msg_list,this.msg_list)
            }
          })
        }
    },
    toMsgShow (id) {
      this.$router.push({
        path: '/msg',
        query: {
          id: id,
        }
      })
    },
    ...mapMutations([mTypes.loginModal, mTypes.logout]),
    loginHandle () {
      this[mTypes.logout]({})
      window.localStorage.clear();
      window.sessionStorage.clear();
      this.$router.push('/login?r=head')
    },
    openwindow (url, name, iWidth, iHeight) {
      var iTop = (window.screen.height - 30 - iHeight) / 2       //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2        //获得窗口的水平位置;

      window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no')
    },
    viewMsg (item) {
      if (item.type === 1) {
        // console.log(item)
      } else if (item.type === 2) {
        this.show_msg_box=false;
        this.toMsgShow(item.id)
      } else if (item.type === 3) {
        this.show_msg_box=false;
        this.openwindow(item.url,'',700,650);
      }
    },
    logout () {
      this[mTypes.logout]({})
      window.localStorage.clear();
      window.sessionStorage.clear();
      if (this.$route.name !== ROUTER_MAP.home) {
        this.$router.push('/')
      }
    },
    personCenter () {
      this.$router.push('/person-center/personInfo')
    },
    toRoom () {
      this.$router.push('/room')
    },
    handleSearch () {
      if (this.searchWord !== '') {
        this.$router.push({
          path: '/course-center',
          query: {
            search: this.searchWord
          }
        })
      } else {
        this.$router.push({
          path: '/course-center'
        })
      }
    },
    throttle (fn, wait) {
      return function (...args) {
        let context = this
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(function () {
          fn.apply(context, args)
        }, wait)
      }
    },
    isScrollBottom () {
      const container = this.$refs.msg_list_div
      var scrollTop = container.scrollTop
      var windowHeight = container.clientHeight
      var scrollHeight = container.scrollHeight
      if ((scrollTop + windowHeight) >= scrollHeight) {
        if (this.msg_list_page < this.msg_list_max) {
          getMsgList({
            pageSize: 5,
            page: this.msg_list_page,
          }).then(response => {
            if (response.code === 1) {
              this.msg_list_max = response.data.maxPage
              if (this.msg_list_max) {
                this.msg_list_page++
              }
              response.data.list.map((item) => {
                if (item.content.length >= 15) {
                  item.content = (item.content.slice(0, 13) + '...')
                }
                this.msg_list.push(item)
              })
              store.commit(mTypes.msg_list,this.msg_list)
            }
          })
        } else {
          console.log('show no msg list')
          this.no_msg_list = true
        }

        this.isBottom = true
      } else {
        this.isBottom = false
      }
    },
    msg_list_div_scroll_listen: function () {
      this.isScrollBottom()
    },
  },
  created () {
    this.searchWord = ''
    if (!store.state.brand_info.length) {
      getBrandSkinConfig().then(response => {
        if (response.code === 1) {
          this.site_text = response.data.brand_name
          this.brand_info=response.data;
          this.site_title = response.data.air_site_title
          this.brand_text = response.data.air_site_name
          this.logoImageUrl = response.data.air_logo_url
          this.logoImageUrl_light = response.data.air_light_logo_url
          this.is_show_famous_read = response.data.is_show_famous_read
          document.querySelector('title').innerText = this.site_title
          store.commit(mTypes.brand_info, response.data)
          window.localStorage.setItem('mfy_brand_config',JSON.stringify(this.brand_info))
          if(this.brand_info){
            if(!this.brand_info.user_session || this.brand_info.user_session.length===0){
              console.log('clear userinfo')
              window.localStorage.removeItem('vuexStorage')
              store.commit(mTypes.userInfo,{})
              // this.$router.push('/login')
            }
          }
          // if(!this.userInfo.length){
            // this.$router.push('/login')
          // }
        }
      })
    } else {
      this.site_text = store.state.brand_info.brand_name
      this.site_title = store.state.brand_info.air_site_title
      this.brand_text = store.state.brand_info.air_site_name
      this.logoImageUrl = store.state.brand_info.air_logo_url
      this.logoImageUrl_light = store.state.brand_info.air_light_logo_url
      this.is_show_famous_read = store.state.brand_info.is_show_famous_read
      this.brand_info=store.state.brand_info;
      document.querySelector('title').innerText = this.site_title
    }
  },
  mounted () {
    document.body.addEventListener('click',(e)=>{
      var hide=true;
      if(this.show_msg_box){
        var target=e.target;
        while (target){
          if(target.className==='ui-msg-list' || target.className==='notice-btn' || target.className==='kjaldfjl'){
            hide=false;
          }
          target=target.parentNode;
        }
      }
      if(hide){
        this.show_msg_box=false;
      }
    })
  },
  beforeCreate () {
  },
  beforeMount () {
  },
  beforeUpdate () {
  },
  updated () {

  },
  beforeDestroy () {
    this.searchWord = ''
  },
  destroyed () {
  },
  activated () {
  }
}
</script>